module.exports = __webpack_public_path__ + "static/media/DSC_0229.ded34a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0229.jpg
// module id = 649
// module chunks = 0